/* v8 ignore start */
import {v4 as uuidv4} from "uuid";

import {JsonModel} from "./jsonModel";

interface IWithUUID {
  uuid: string;
}

export class BaseModel<TJson extends IWithUUID> extends JsonModel<TJson> {
  public constructor(json: Omit<TJson, "uuid"> & Partial<IWithUUID>) {
    super({
      ...(json as TJson),
      uuid: json.uuid || uuidv4(),
    });
  }

  public update(partial: Partial<Omit<TJson, "uuid">>): this {
    return new (this.constructor as any)({
      ...this.toObject(),
      uuid: this.uuid,
      ...partial,
    });
  }

  public resetUuid(): this {
    return new (this.constructor as any)({...this.toObject(), uuid: uuidv4()});
  }

  public get uuid(): string {
    return this.json.uuid;
  }
}

export namespace BaseModel {
  export interface IType<TJson extends IWithUUID> {
    new (json: Omit<TJson, "uuid"> & Partial<IWithUUID>): any;
  }
  export type TJson<T extends IType<any>> = T extends IType<infer R> ? R : any;
}
/* v8 ignore stop */
